class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    this.swiperImplementation();
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
// Swiper Code Custom


// Swiper Code Custom Ends here 
      })
      .catch(e => {
        console.error(e);
      });
  }

  swiperImplementation(){
   let cartRecoomItemsSwiper;

function initializeCartRecoomItemsSwiper() {
  if (!cartRecoomItemsSwiper) {
    cartRecoomItemsSwiper = new Swiper('.mini-cart-swiper-recommendation-initialize', {
      // Optional parameters
      loop: true,
      // If we need pagination
      pagination: {
        el: '.mini-cart-swiper-recommendation-initialize .swiper-pagination',
      },
      slidesPerView: "1",
      // Navigation arrows
      navigation: {
        nextEl: '.mini-cart-swiper-recommendation-initialize .swiper-button-next',
        prevEl: '.mini-cart-swiper-recommendation-initialize .swiper-button-prev',
      }
    });
  }
}

setTimeout(function() {
  const swiperElement = document.querySelector('.mini-cart-swiper-recommendation-initialize');
  if (swiperElement && !swiperElement.swiper) {  }
    initializeCartRecoomItemsSwiper();
  console.log("testing");
}, 2000);
  }
}
customElements.define('cart-recommendations', CartRecommendations);